// @ts-check

import "../jsdoc-types"
import classNames from 'classnames';
import { GridCell } from "./GridCell";

/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @param {GridContainerEntry} props.cdaEntry
 */
export function GridContainer({ className, cdaEntry }) {
	return (
		<div
			className={ classNames("service-page-grid-container", {
				"--align-left": !cdaEntry.fields.alignment || cdaEntry.fields.alignment === "left",
				"--align-center": cdaEntry.fields.alignment === "center",
				"--align-right": cdaEntry.fields.alignment === "right",
			}, className) }
		>
			{cdaEntry.fields.cells?.map((cell) => (
				<GridCell key={`${cdaEntry.sys.id}_${cell.sys.id}`} cdaEntry={ cell } />
			))}
		</div>
	);
}
